import type { Encounter, Practitioner } from '@medplum/fhirtypes';
import { formatPractitionerPreferredLabel } from '@unify/fhir-model/resources/practitioner';

/** Assessment / bot-created Encounters may omit `period`; fall back so the portal never shows Invalid Date. */
export function encounterPortalDateRaw(enc: Encounter): string {
  const start = enc.period?.start?.trim();
  if (start) return start;
  const end = enc.period?.end?.trim();
  if (end) return end;
  const updated = enc.meta?.lastUpdated?.trim();
  if (updated) return updated;
  return '';
}

export function formatPractitionerHumanName(p: Practitioner): string {
  return formatPractitionerPreferredLabel(p);
}

export function practitionerIdFromEncounter(enc: Encounter): string | undefined {
  const part = enc.participant?.find((x) => x.individual?.reference?.startsWith('Practitioner/'));
  const ref = part?.individual?.reference;
  if (!ref?.startsWith('Practitioner/')) return undefined;
  return ref.slice('Practitioner/'.length);
}
